/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */
import axios from 'axios';
import { environment } from '../Environment';
const client = axios.create();
export const restClient = {
    getCompiledProblem: async (problemId) => await client.get(`${environment.webAddress}/controller/api/${environment.accessKey}/problems/${problemId}/compile`)
};
